var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg7SLogoColored = function Svg7SLogoColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aberhatschi1407",
    d: "M0 20.581h15.09L6.757 34.993A19.942 19.942 0 0 1 0 20.581zm12.227-6.28H.814C3.269 6.031 10.921 0 19.985 0c4.42 0 8.504 1.437 11.815 3.866H20.078c-3.238 0-8.057 2.226-8.057 8.358 0 .75.073 1.44.206 2.076zm25.156-4.154A19.885 19.885 0 0 1 39.985 20c0 11.046-8.954 20-20 20a19.93 19.93 0 0 1-7.923-1.634l10.283-17.784h5.68c1.816.08 1.816 1.479 1.816 2.076 0 .599 0 1.997-1.816 2.078h-7.128l-1.577 2.727h8.733c.183 0 4.504-.072 4.504-4.805 0-4.731-4.32-4.803-4.504-4.804l-7.282.001L9.634 37.116a19.653 19.653 0 0 1-.696-.445l10.88-18.817H.1c.03-.277.064-.553.105-.827H17.22c-1.264-.74-2.47-2.142-2.47-4.803 0-5.567 5.276-5.63 5.329-5.63h14.746c.243.268.477.544.705.825H20.078c-.183.001-4.503.073-4.503 4.805 0 4.47 3.823 4.782 4.428 4.803h1.247l-.001.002 6.804-.002c.054 0 5.33.065 5.33 5.631 0 5.567-5.276 5.631-5.33 5.631h-9.21l-1.578 2.728h10.8c3.238 0 8.057-2.226 8.057-8.359 0-6.132-4.819-8.358-8.057-8.358h-8.003a2.914 2.914 0 0 1-.97-.284c-.276-.147-.79-.419-.79-1.792 0-.598 0-1.996 1.816-2.077h17.265z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "aberhatschi14071994",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aberhatschi1407"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#2D3233",
    xlinkHref: "#aberhatschi1407"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00B1E1",
    mask: "url(#aberhatschi14071994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  })))));
};
export default Svg7SLogoColored;